import gql from 'graphql-tag';

export const SpaceUnlicensedPermissionMutation = gql`
	mutation RemoveSpaceUnlicensedPermissionMutation(
		$spaceKey: String!
		$permissionId: ExperimentalLong!
	) @experimental {
		experimentalRemoveUnlicensedPermission(spaceKey: $spaceKey, permissionId: $permissionId) {
			success
		}
	}
`;
